// Copyright (c) 2024 - Present. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { Project } from '@/project/api/types';
import { pluralize } from '@/utilities/pluralize';
import { Typography, TypographyProps } from '@mui/material';

const DEFAULT_FORMAT_OPTIONS: Intl.DateTimeFormatOptions = {
  dateStyle: 'medium',
};

interface Props extends Pick<TypographyProps, 'variant' | 'whiteSpace'> {
  project: Pick<Project, 'startOn' | 'isArchived'>;
  formatOptions?: Intl.DateTimeFormatOptions;
}

export function ProjectStartDateLabel(props: Props) {
  const formatOptions = props.formatOptions ?? DEFAULT_FORMAT_OPTIONS;

  if (props.project.startOn === null) {
    const color = props.project.isArchived ? 'text.disabled' : 'text.secondary';

    return (
      <Typography
        color={color}
        variant={props.variant}
        whiteSpace={props.whiteSpace}
      >
        Not set
      </Typography>
    );
  }

  const color = props.project.isArchived ? 'text.disabled' : 'text.primary';
  const difference = props.project.startOn.diffNow('days');
  const dateLabel = props.project.startOn.toLocaleString(formatOptions);
  const countLabel = pluralize(Math.floor(difference.days), {
    singular: 'day',
  });

  return (
    <Typography
      color={color}
      variant={props.variant}
      whiteSpace={props.whiteSpace}
    >
      {dateLabel} ({countLabel})
    </Typography>
  );
}
